import { Sprite, Text, TextStyle } from "pixi.js";
import { ButtonWithScaleAnimation } from "../../../common/components/ButtonWithScaleAnimation";
import { GameFont } from "../../../common/GameFont";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";

export class SeeBuildingInButton extends ButtonWithScaleAnimation {
    private static readonly BUTTON_TEXT = "SEE BUILDING IN";

    private readonly marketPlaceButtonText: Text;
    private readonly marketplaceIcon: Sprite;

    public constructor(commonResources: CommonResourcesPackage) {
        super(commonResources.assets_common_ui_button_green_blue_png);
        this.defaultView.width = 267;
        this.defaultView.height = 127;
        this.marketPlaceButtonText = new Text(SeeBuildingInButton.BUTTON_TEXT, new SeeBuildingInButtonTextStyle());
        this.marketPlaceButtonText.position.set(18, 42);
        this.addChild(this.marketPlaceButtonText);
        this.marketplaceIcon = new Sprite(commonResources.assets_common_ui_vector_png);
        this.marketplaceIcon.width = 38;
        this.marketplaceIcon.height = 35;
        this.marketplaceIcon.position.set(this.marketPlaceButtonText.position.x + this.marketPlaceButtonText.width + 3, this.marketPlaceButtonText.position.y);
        this.addChild(this.marketplaceIcon);
    }

    public showDefaultStyle(): void {
        this.defaultView.width = 267;
        this.defaultView.height = 127;

        this.marketPlaceButtonText.position.set(18, 42);
        this.marketplaceIcon.position.set(this.marketPlaceButtonText.position.x + this.marketPlaceButtonText.width + 3, this.marketPlaceButtonText.position.y);
    }

    public showUpgradeStyle(): void {
        this.defaultView.width = 465;
        this.defaultView.height = 130;

        this.marketPlaceButtonText.position.set(113, 24);
        this.marketplaceIcon.position.set(this.marketPlaceButtonText.position.x + this.marketPlaceButtonText.width + 3, this.marketPlaceButtonText.position.y);
    }
}

class SeeBuildingInButtonTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 40,
            dropShadow: true,
            dropShadowColor: "#0d0606",
            dropShadowAlpha: 0.3,
            dropShadowAngle: 0.82859,
            dropShadowBlur: 5
        }));
    }
}